export const ERROR_CODE = {
  TELEMATIC_PROVIDER_ACCOUNT_EXISTS: 'TELEMATIC_PROVIDER_ACCOUNT_EXISTS',
  MONITORING_ORDER_SNAPSHOT_NOT_FOUND: 'MONITORING_ORDER_SNAPSHOT_NOT_FOUND',
  PROVIDER_ACCOUNT_BAD_CREDENTIALS: 'PROVIDER_ACCOUNT_BAD_CREDENTIALS',
  PROVIDER_ACCOUNT_NO_DEVICES: 'PROVIDER_ACCOUNT_NO_DEVICES',
  SCANIA_VAT_NUMBER_NOT_FOUND: 'SCANIA_VAT_NUMBER_NOT_FOUND',
  CONNECTIVITY_AGREEMENT_NOT_SIGNED: 'CONNECTIVITY_AGREEMENT_NOT_SIGNED',
  PROVIDER_AUTHENTICATOR_NOT_FOUND: 'PROVIDER_AUTHENTICATOR_NOT_FOUND',
  IDEM_VAT_NUMBER_AND_VINS_NOT_MATCHED: 'IDEM_VAT_NUMBER_AND_VINS_NOT_MATCHED',
  KOEGEL_VAT_NUMBER_AND_VINS_NOT_MATCHED: 'KOEGEL_VAT_NUMBER_AND_VINS_NOT_MATCHED',
  SCHWARZMULLER_VAT_NUMBER_AND_VINS_NOT_MATCHED: 'SCHWARZMULLER_VAT_NUMBER_AND_VINS_NOT_MATCHED',
  PROVIDER_AUTH_TOKEN_GET_FAILED: 'PROVIDER_AUTH_TOKEN_GET_FAILED',
  ESTIMATION_EXCEPTION: 'ESTIMATION_EXCEPTION',
  DRIVE_TIME_NOT_AVAILABLE_FOR_ASSET: 'DRIVE_TIME_NOT_AVAILABLE_FOR_ASSET',
};

const ERROR_STATUS = {
  GATEWAY_TIMEOUT: 504,
};

const IGNORED_ERROR_CODES = [
  ERROR_CODE.TELEMATIC_PROVIDER_ACCOUNT_EXISTS,
  ERROR_CODE.MONITORING_ORDER_SNAPSHOT_NOT_FOUND,
  ERROR_CODE.PROVIDER_ACCOUNT_BAD_CREDENTIALS,
  ERROR_CODE.PROVIDER_ACCOUNT_NO_DEVICES,
  ERROR_CODE.SCANIA_VAT_NUMBER_NOT_FOUND,
  ERROR_CODE.CONNECTIVITY_AGREEMENT_NOT_SIGNED,
  ERROR_CODE.PROVIDER_AUTHENTICATOR_NOT_FOUND,
  ERROR_CODE.IDEM_VAT_NUMBER_AND_VINS_NOT_MATCHED,
  ERROR_CODE.KOEGEL_VAT_NUMBER_AND_VINS_NOT_MATCHED,
  ERROR_CODE.SCHWARZMULLER_VAT_NUMBER_AND_VINS_NOT_MATCHED,
  ERROR_CODE.PROVIDER_AUTH_TOKEN_GET_FAILED,
  ERROR_CODE.ESTIMATION_EXCEPTION,
  ERROR_CODE.DRIVE_TIME_NOT_AVAILABLE_FOR_ASSET,
];

const IGNORED_ERROR_STATUSES = [ERROR_STATUS.GATEWAY_TIMEOUT];

export const isIgnoredErrorCode = (errorCode) => IGNORED_ERROR_CODES.includes(errorCode);

export const isIgnoredErrorStatus = (errorStatus) => IGNORED_ERROR_STATUSES.includes(errorStatus);
